export default "__VITE_ASSET__BpySJxXu__"